<template>
  <div>
    <div class="login-panel">
      <div class="main">
        <div class="left">
          <h2 class="title">Reset Password</h2>
          <form class="form" @submit.prevent="save">
            <p class="m-b-50">{{email}}</p>
            <div
              class="form-group"
              :class="{active: form.password || formFocus.password, error: $v.form.password.$error}"
            >
              <p class="label">{{$t('password')}}</p>
              <input
                class="input"
                autocomplete="off"
                autofocus="autofocus"
                @focus="focus('password')"
                @blur="blur('password')"
                v-model.trim="form.password"
                type="password"
              >
              <vd-tips path="form.password"/>
            </div>
            <div
              class="form-group"
              :class="{active: form.confirm_password || formFocus.confirm_password, error: $v.form.confirm_password.$error}"
            >
              <p class="label">{{$t('confirmPassword')}}</p>
              <input
                class="input"
                autocomplete="off"
                autofocus="autofocus"
                @focus="focus('confirm_password')"
                @blur="blur('confirm_password')"
                v-model.trim="form.confirm_password"
                type="password"
              >
              <vd-tips path="form.confirm_password"/>
            </div>
            <button class="submit" type="submit">{{$ct('confirm1')}}</button>
          </form>
          <p class="tips">
            <router-link :to="iPath('/login')">{{$t('login')}}</router-link>
          </p>
        </div>
        <div class="right"></div>
      </div>
      <ul class="footer">
        <li>
          <router-link :to="iPath('/termsService')">{{$ct('termsService')}}</router-link>
        </li>
        <li>
          <router-link :to="iPath('/privacyPolicy')">{{$ct('privacyPolicy')}}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { iPath } from '@/utils/i18n'
import { patch, get } from '@/utils/ajax'
import { required, sameAs, validationMixin, minLength, maxLength } from '@/utils/mixin_validate'
export default {
  inject: ['iPath'],
  mixins: [validationMixin({ tipsType: '' })],
  beforeRouteEnter({ query: { code, email } }, from, next) {
    if (!code || !email) return next(iPath('/'))
    next()
  },
  data() {
    const query = this.$route.query
    return {
      formFocus: {
        username: false,
        password: false,
        confirm_password: false
      },
      email: query.email || '--',
      form: {
        code: query.code,
        password: '',
        confirm_password: ''
      }
    }
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(20)
      },
      confirm_password: {
        required,
        sameAs: sameAs('password')
      }
    }
  },
  computed: {
    validators() {
      return {
        form: {
          password: {
            required: this.$ct('messages.required'),
            minLength: this.$ct('messages.min', [6]),
            maxLength: this.$ct('messages.max', [20])
          },
          confirm_password: {
            required: this.$ct('messages.required'),
            sameAs: this.$ct('messages.passwordSame')
          }
        }
      }
    }
  },
  methods: {
    focus(item) {
      this.formFocus[item] = true
    },
    blur(item) {
      this.formFocus[item] = false
    },
    async save() {
      if (!this.form.code) return false
      await this.validationTouch()
      await patch('/edu/zone/password/reset', this.form)
      this.$message.success(this.$t('csuccess'))
      const store = this.$store
      if (store.state.token) {
        await get('/edu/zone/exit')
        store.commit('LOGOUT')
      }
      this.$router.push(this.iPath('/login'))
    }
  }
}
</script>
<i18n lang="yaml">
en:
  title: Forgot Password
  login: Log In
  password: Password
  confirmPassword: Confirm Password
zh-CN:
  title: 忘记密码
  login: 登录
  password: 密码
  confirmPassword: 确认密码
zh-TW:
  title: 忘記密碼
  login: 登錄
  password: 密碼
  confirmPassword: 確認密碼
it:
  title: Password dimenticata
  login: Accesso
  password: Password
  confirmPassword: Conferma Password
id:
  title: Lupa Kata sandi
  login: Masuk
  password: Kata sandi
  confirmPassword: Konfirmasi kata sandi
</i18n>
